
export const SET_YEAR_STAFF_ALLOCATION = 'SET_YEAR_STAFF_ALLOCATION';
export const SET_MONTH_STAFF_ALLOCATION = 'SET_MONTH_STAFF_ALLOCATION';

export const GET_STAFF_ALLOCATION_START = 'GET_STAFF_ALLOCATION_START';
export const GET_STAFF_ALLOCATION_SUCCESS = 'GET_STAFF_ALLOCATION_SUCCESS';
export const GET_STAFF_ALLOCATION_FAIL = 'GET_STAFF_ALLOCATION_FAIL';

export const SET_RECORD_TO_EDIT_STAFF_ALLOCATION = 'SET_RECORD_TO_EDIT_STAFF_ALLOCATION';